import { useMemo, useSyncExternalStore } from 'react'
import {
  navigateTo,
  parseAppRoute,
  subscribeToNavigation,
  isAgenciesSection,
} from '@/utils/routing'

function getPathname(): string {
  return window.location.pathname
}

export function useAppRoute() {
  const pathname = useSyncExternalStore(
    subscribeToNavigation,
    getPathname,
    () => '/agencies',
  )

  const route = useMemo(() => parseAppRoute(pathname), [pathname])

  return useMemo(
    () => ({
      route,
      path: route.kind === 'login' ? '/login' : '/agencies',
      agencyId: route.kind === 'agencyDetail' ? route.agencyId : null,
      isLoginRoute: route.kind === 'login',
      isAgenciesListRoute: route.kind === 'agencies',
      isAgencyDetailRoute: route.kind === 'agencyDetail',
      isAgenciesRoute: isAgenciesSection(route),
      navigateToLogin: () => navigateTo({ kind: 'login' }),
      navigateToAgencies: () => navigateTo({ kind: 'agencies' }),
      navigateToAgency: (agencyId: string) =>
        navigateTo({ kind: 'agencyDetail', agencyId }),
      navigateToShell: () => navigateTo({ kind: 'agencies' }),
    }),
    [route],
  )
}
